import { render, staticRenderFns } from "./DSCrossInsideCircleIcon.vue?vue&type=template&id=340fd430&"
import script from "./DSCrossInsideCircleIcon.vue?vue&type=script&lang=js&"
export * from "./DSCrossInsideCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports